import { useContext, useEffect, useState } from "react";
import ProductTypeApi from "../../api/product-type";
import AuthContext from "../../components/auth-context";
import ProductBox from "../../components/product/item";
import SearchFilters from "../../components/search-filters";
import FilterWrapper from "../../components/search-filters/filter-wrapper";
import { getCopyOf, localizeNumbers, unLocalizeNumbers } from "../../functions";
import Product from "../../types/product";
import ProductTypeSpecs, {
  ProductTypeSpec,
  SpecDisplay,
} from "../../types/prtoduct-type-specs";
import Row from "../../components/tailwind/row";
import Col from "../../components/tailwind/col";
import NgnLineSpecsApi from "../../api/ngn-line-specs";
import ProductApi from "../../api/product";
export interface ISelectLineProps {
  onSelectLine: (number: string) => void;
  handleClick: (id: number, title: string) => void;
  isNgnSignup?: boolean;
}

export interface ngnProvinces {
  [id: string]: string;
}

export default function Selectline({
  onSelectLine,
  handleClick,
}: ISelectLineProps) {
  let [products, setProducts] = useState<Product[]>([]);
  let [productSpecs, setProductSpecs] = useState<ProductTypeSpecs>({});
  let [selectedNgnProvince, setSelectedNgnProvince] = useState<string>("30001");
  let [ngnProvinces, setNgnProvinces] = useState<ngnProvinces>({});

  const context = useContext(AuthContext);
  const { activeFileId, ngnSelectedProvince } = context;
  let productType = 10;

  useEffect(() => {
    console.log("products", products);

    const productApi = new ProductApi(context);
    const productTypeApi = new ProductTypeApi(context);
    console.log("activeFileId", activeFileId);
    productApi
      .getAll(null, 10)
      .then((result: any) => setProducts(result))
      .catch((err: any) => console.error("Error fetching products:", err));

    productTypeApi
      .get(productType, null)
      .then((result: any) => {
        if (result) setProductSpecs(result.specs);
      })
      .catch((err: any) => console.error("Error fetching product types:", err));
    console.log("result.specs", productSpecs);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const productTypeApi = new NgnLineSpecsApi(context);
    productTypeApi
      .get(productType)
      .then((result: any) => {
        if (result && result.specs && result.specs[7]) {
          setNgnProvinces(result.specs[7].values);
        }
      })
      .catch((error: any) => {
        console.error("Error fetching product specs:", error);
      });
  }, [context, productType]);

  const selectedValuesChanges = (specId: string, data: string[]) => {
    let specs = getCopyOf(productSpecs);
    if (specs[specId]) {
      specs[specId].selectedValues = data ? [...data] : null;
      setProductSpecs(specs);
    }
  };

  const handleNgnProvince = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedNgnProvince(event.target.value);
  };

  const selectedRangeChanges = (specId: string, data: number[]) => {
    let specs = getCopyOf(productSpecs);
    if (specs[specId]) {
      specs[specId].selectedRange = data ? [...data] : null;
      setProductSpecs(specs);
    }
  };

  const isInRangeOfSpec = (spec: ProductTypeSpec, value: number) => {
    if (spec?.selectedRange) {
      return spec.selectedRange[0] <= value && spec.selectedRange[1] >= value;
    }
    return true;
  };

  const getSortedFilteredProducts = () => {
    if (!products) return [];
    return filterProducts(products);
  };

  const filterProducts = (products: Product[]) => {
    let contextSelectedNgnProvince =
      ngnSelectedProvince || Number(selectedNgnProvince);

    return products.filter(
      (product) =>
        isInRangeOfSpec(productSpecs[255], product.finalPrice) &&
        product.specs.every((spec) => {
          console.log("filterProducts.spec", spec, productSpecs);

          if (!(spec.specId in productSpecs)) return false;
          const { selectedValues } = productSpecs[spec.specId];
          if (spec.specId === 7 && spec.value !== contextSelectedNgnProvince) {
            return false;
          }

          switch (productSpecs[spec.specId].display) {
            case SpecDisplay.CheckBox:
            case SpecDisplay.DropDown:
            case SpecDisplay.RadioButton:
              if (!selectedValues || selectedValues.length === 0) return true;
              return selectedValues.includes(
                `${spec.value == null ? "" : spec.value}`
              );
            case SpecDisplay.Search:
              if (!selectedValues || selectedValues.length === 0) return true;
              var value = spec.value == null ? "" : `${spec.value}`;
              return localizeNumbers(value).includes(
                localizeNumbers(selectedValues[0])
              );
            case SpecDisplay.Slider:
              return isInRangeOfSpec(productSpecs[spec.specId], spec.value);
            default:
              return true;
          }
        })
    );
  };

  const specs = Object.keys(productSpecs)
    .filter((specId) => specId !== "7")
    .map((specId) => (
      <FilterWrapper
        key={specId}
        spec={productSpecs[specId]}
        selectedRangeChanges={(r) => selectedRangeChanges(specId, r)}
        selectedValuesChanges={(v) => selectedValuesChanges(specId, v)}
      />
    ));

  return (
    <>
      <header className="page-header text-primary py-10"></header>
      <Row>
        <ul>
          <li>
            در هیچ صورت مبلغ نقدی برگردانده نخواهد شد تنها بازگشت مبلغ در قالب
            اعتبار رایگان و قابل استفاده در خریدهای بعدی خواهد بود.
          </li>
          <li>
            انتخاب خط به معنای پذیرش{" "}
            <b>
              <a href="/docs/CustomerContract.pdf" target="_blank">
                قرارداد
              </a>
            </b>{" "}
            می‌باشد.
          </li>
          <li>
            برای خرید خط تلفن، می‌بایست از سپنتا اینترنت(ADSL / TD-LTE /
            Wireless) داشته باشید.
          </li>
        </ul>
      </Row>

      {!ngnSelectedProvince && (
        <Row>
          <div className="form-section rtl flex flex-wrap xs:flex-col sm:flex-row gap-6 p-4">
            <div className="flex flex-col rtl text-right mt-4 relative">
              استان خود جهت استفاده از تلفن اینترنتی را انتخاب کنید
              <select
                id="province"
                value={selectedNgnProvince}
                className="mt-2 p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                onChange={handleNgnProvince}
              >
                {Object.entries(ngnProvinces).map(([id, name]) => (
                  <option value={id} key={id}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Row>
      )}

      <Row className="pt-30 pb-30 pr-0 pl-0">
        <SearchFilters
          className="col-12 col-lg-3 py-10"
        >
          {specs}
        </SearchFilters>
        <Col className="col-lg-9 pb-3 pr-0">
          <Row className="d-flex justify-content-center mx-1 mx-lg-0">
            {getSortedFilteredProducts().map((product) => (
              <ProductBox
                Specs={productSpecs}
                productSpecs={product.specs}
                key={product.id}
                title={product.title}
                finalPrice={product.finalPrice}
                mainPrice={product.mainPrice}
                packageTitle={product.packageTitle}
                desc={product.desc}
                hasSnappPay={product.hasSnappPay}
                onSelect={() => onSelectLine(product.title)}
                onhandleClick={() =>
                  handleClick(product.id, unLocalizeNumbers(product.title))
                }
              />
            ))}
          </Row>
        </Col>
      </Row>
    </>
  );
}
